import { useState } from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Link from '@mui/material/Link';
import EditIcon from '@mui/icons-material/Edit';

import { format, parseISO } from 'date-fns';

import { openDownloadWindow } from '../../../../utils/openDownloadWindow';
import DeleteButton from '../../../../common/components/DeleteButton/DeleteButton';
import ActionGroup from '../../../../common/components/ActionGroup';
import Button from '@mui/material/Button';
import {Permission} from "../../../../components/SessionInfo";
import {hetch} from "../../../../utils/fetch.hooked";

function KeysTableRow({keyId, keyName, startDate, expireDate, status, setCurrentKeyInfo, setEditModalOpen, permission, handleRemoveRow}) {
  const [isFetching, setIsFetching] = useState(false);

  const removeItem = () => {
    setIsFetching(true);
    hetch(`/api/keys/${keyId}`, {
      headers: {'Content-Type': 'application/json'},
      method: 'DELETE',
      body: null
    })
      .then(() => {
        handleRemoveRow(keyId);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }

  return (
    <TableRow sx={{'&:last-child td, &:last-child th': {border: 0}}}>
      <TableCell>{startDate ? format(parseISO(startDate), 'dd.MM.yyyy HH:mm:ss') : '—'}</TableCell>
      <TableCell>{expireDate ? format(parseISO(expireDate), 'dd.MM.yyyy HH:mm:ss') : '—'}</TableCell>
      <TableCell>{status}</TableCell>
      <TableCell>
        <Link
          component='button'
          variant='button'
          disabled={isFetching}
          sx={{fontWeight: 'initial', textTransform: 'initial'}}
          onClick={() => openDownloadWindow(`/api/keys/${keyId}/public-key`)}
        >
          Скачать
        </Link>
      </TableCell>
        {permission === Permission.WRITE
            ?  <TableCell align='right'>
                <ActionGroup align='right'>
                  <Button
                    title="Редактировать УКЭП"
                    variant="contained"
                    color="primary"
                    disabled={isFetching}
                    onClick={() => {
                      setCurrentKeyInfo({keyId, keyName, startDate, expireDate, status});
                      setEditModalOpen(true);
                    }}
                  >
                    <EditIcon/>
                  </Button>
                  <DeleteButton
                    title="Удалить УКЭП"
                    message="Вы действительно хотите удалить УКЭП?"
                    isFetching={isFetching}
                    onConfirm={() => removeItem()}
                  />
                </ActionGroup>
              </TableCell>
            : null
        }
    </TableRow>
  );
}

export default KeysTableRow;
